//记得在 src\components\lang\zhLoad.js 里面添加对象
const taskApproval = {
  taskPkgNo:'任务包ID',
  taskPkgName: '任务名称',
  taskPkgTypeName: '任务类型',
  areaName: '适用大区',
  taskPkgFetchUserName: '领取人',
  taskPkgFetchStoreCount: '打卡数量',
  taskPkgStatusName: '状态',
  updateTime:'最后更新',
  waitApproveStoreCount: '待审核数量',
  taskPkgPeriodDate: '任务周期',
  waitApproveFlag: '待审核门店',
  approveRemark: '拒绝原因',
  customerName: 'customerName',
  cityName: 'cityName',
  msg: {}
};
export default taskApproval



// WEBPACK FOOTER //
// ./src/page/taskManagement/taskApproval/lang/taskApproval.en.js